<template>
    <div>
        <v-row>
            <v-col>

                <v-toolbar style="margin: 15px 0" elevation="1">
                    <v-text-field class="mt-4" v-model="search" label="Buscar" single-line hide-details></v-text-field>
                </v-toolbar>
                <v-card elevation="1">
                    <!-- :single-expand="singleExpand"
              :expanded.sync="expanded"
                   show-expand -->
                    <v-data-table :headers="headers" :items="items" :search="search" :loading="loading"
                        :server-items-length="totalRegisters" :options.sync="options" item-key="id"><!--:sort-by="[ 'finishOn']"
              :sort-desc="[ false]"-->
                        <template v-slot:[`item.profileName`]="{ item }">
                            {{ item.profileName }}
                            <v-tooltip top color="grey darken-3">
                                <template v-slot:[`activator`]="{ on, attrs }">
                                    <v-btn icon v-bind="attrs" v-on="on" color="orange lighten-1">
                                        <v-icon size="12px">
                                            mdi-information-outline
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <div>Nome do perfil: <strong>{{ item.profileDisplayName }}</strong></div>
                                <div>Razão Social: <strong>{{ item.profileName }}</strong></div>
                                <div>ID do perfil: <strong>{{ item.profileId }}</strong></div>
                            </v-tooltip>
                        </template>
                        <template v-slot:[`item.logo`]="{ item }">
                            <!-- {{ JSON.stringify(item.created.user)}} -->
                            <v-img :src="item.logo" width="60" height="60" class="ml-n4" cover></v-img>
                        </template>
                        <template v-slot:[`item.publishersDisplayName`]="{ item }">
                            {{ item.publishersDisplayName[0] }}
                            <v-tooltip top color="grey darken-3" v-if="item.publishersDisplayName.length > 1">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon v-bind="attrs" v-on="on" color="orange lighten-1">
                                        <span style="font-size: 10px;">({{ item.publishersDisplayName.length }})</span>
                                        <v-icon size="12px">
                                            mdi-information-outline
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <div class="px-0" v-for="(pub, i) in item.publishersDisplayName" :key="i">Veículo:
                                    <strong>{{ pub }} ({{
                                        item.publishers[i]
                                    }})</strong>
                                </div>
                            </v-tooltip>
                        </template>
                        <template v-slot:[`item.grid.ordersCount`]="{ item }">
                            {{ item.grid.ordersCount }} item(s)
                        </template>

                        <template v-slot:[`item.grid.placementRange`]="{ item }">
                            <!-- {{JSON.stringify(item.grid)}} -->
                            {{ formatDate(item.grid.placementRange.start) }} à
                            {{ formatDate(item.grid.placementRange.end) }}
                        </template>



                        <template v-slot:[`item.createdOn`]="{ item }">
                            {{ $moment(item.createdOn).format("DD/MM/YYYY HH:mm") }}
                        </template>
                        <template v-slot:[`item.statusId`]="{ item }">
                            <span v-if="item.statusId == 1" class="primary--text"><strong>Pendente</strong></span>
                            <span v-if="item.statusId == 2" class="red--text"><strong>Inativo</strong></span>
                            <span v-if="item.statusId == 3" class="green--text"><strong>Ativo</strong></span>
                        </template>





                        <template v-slot:[`item.actions`]="{ item }">
                            <span class="d-flex">
                                <v-btn icon class="mr-2" @click="snap = item">
                                    <!-- mdi-view-list -->
                                    <v-icon small>
                                        mdi-file-find
                                    </v-icon>
                                </v-btn>
                                <!-- <v-icon small color="red" @click="remove = item"> mdi-delete </v-icon> -->
                            </span>
                        </template>

                        <!-- <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length" style="padding: 0.5rem">
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th>Pergunta</th>
                          <th>Resposta</th>
                          <th>Tempo (Seg.)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td></td>
                          <td>{{ item.profileId }}</td>
                          <td>teste</td>
                        </tr>
                        <tr>
                          <td></td>
                          <td>teste</td>
                          <td>teste</td>
                        </tr>
                        <tr>
                          <td></td>
                          <td>teste</td>
                          <td>teste</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </td>
              </template> -->
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog v-model="show" width="1280">
            <!-- <ExternalServices :snap="snap" v-if="show" @show-services="show = $event"></ExternalServices> -->
            <v-card class="mx-auto" v-if="snap" :loading="loadingSnap">
                <v-card-title>
                    {{ snap.displayName }}
                    <v-spacer></v-spacer>
                    <v-btn icon @click="show = false"><v-icon>mdi-close</v-icon></v-btn>
                </v-card-title>
                <v-card-text v-if="!loadingSnap">
                    <v-tabs v-model="snapTab">
                        <v-tab>Informações de Perfil</v-tab>
                        <v-tab :disabled="!snapDocument.config">Configurações</v-tab>
                    </v-tabs>
                    <v-divider class="pb-3 mb-3"></v-divider>

                    <v-tabs-items v-model="snapTab">
                        <v-tab-item>
                            <v-row>
                                <v-col cols="12" md="1"><v-img :src="snap.logo"></v-img></v-col>
                                <v-col cols="12" md="1"><v-text-field class="mt-2" label="ID" v-model="snap.id" readonly
                                        outlined></v-text-field></v-col>
                                <v-col cols="12" md="10"><v-text-field class="mt-2" label="Nome" v-model="snap.displayName"
                                        readonly outlined></v-text-field></v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="6"><v-text-field label="Nome Fantasia" v-model="snap.tradingName"
                                        readonly outlined></v-text-field></v-col>
                                <v-col cols="12" md="6"><v-text-field label="CNPJ" v-model="snap.document" readonly
                                        outlined></v-text-field></v-col>
                            </v-row>
                            <fieldset v-if="snapDocument.users">
                                <legend>Usuários</legend>
                                <v-card v-for="user in snapDocument.users" :key="user.id" outlined class="pa-2 mb-2">

                                    <v-row>
                                        <v-col cols="12" md="1"><v-text-field label="ID" v-model="user.id" readonly
                                                outlined></v-text-field></v-col>
                                        <v-col cols="12" md="1"><v-switch :label="user.emailConfirm ? 'Verificado' : 'Não'"
                                                readonly></v-switch></v-col>
                                        <v-col cols="12" md="4"><v-text-field label="Nome" v-model="user.name" readonly
                                                outlined></v-text-field></v-col>
                                        <v-col cols="12" md="6"><v-text-field label="Email" v-model="user.email" readonly
                                                outlined></v-text-field></v-col>
                                    </v-row>
                                    <v-card outlined class="pa-2 mb-2" v-for="(con, i) in user.phones" :key="con.id">
                                        <v-row>
                                            <v-col cols="12" md="1"><v-avatar size="28" color="grey">{{ i + 1
                                            }}</v-avatar></v-col>
                                            <v-col cols="12" md="5"><v-text-field hide-details label="Telefone"
                                                    v-model="user.contact" readonly outlined></v-text-field></v-col>
                                            <v-col cols="12" md="6"><v-text-field hide-details label="Contato"
                                                    v-model="user.name" readonly outlined></v-text-field></v-col>
                                        </v-row>
                                    </v-card>
                                    <v-row>
                                        <v-col cols="12" md="1"><v-text-field label="Língua" v-model="user.language"
                                                readonly outlined></v-text-field></v-col>
                                        <v-col cols="12" md="5"><v-text-field label="Fuso" v-model="user.timezone" readonly
                                                outlined></v-text-field></v-col>
                                        <v-col cols="12" md="6"><v-text-field label="Data"
                                                :value="user.createdOn | dateTimeTz" readonly
                                                outlined></v-text-field></v-col>
                                    </v-row>

                                </v-card>
                            </fieldset>


                        </v-tab-item>
                        <v-tab-item v-if="snapDocument.config">
                            <fieldset>
                                <legend>Mídia Kit</legend>
                                <v-row v-for="(file, i) in snapDocument.config.files.midiaKit" :key="i">
                                    <v-col cols="12" md="6" class="black--text">{{ file.name }}</v-col>
                                    <v-col cols="12" md="2" class="black--text">{{ file._type }}</v-col>
                                    <v-col cols="12" md="2" class="black--text">{{ file.size | bytes }}</v-col>
                                    <v-col cols="12" md="2"><v-btn :href="file.url" target="_blank"
                                            icon><v-icon>mdi-download</v-icon></v-btn></v-col>
                                </v-row>
                                <v-alert text color="warning" v-if="!snapDocument.config.files.midiaKit.length">Nenhum midia
                                    kit encontrado</v-alert>
                            </fieldset>
                            <fieldset>
                                <legend>Tabela de preços</legend>
                                <v-row v-for="(file, i) in snapDocument.config.files.priceTable" :key="i">
                                    <v-col cols="12" md="6" class="black--text">{{ file.name }}</v-col>
                                    <v-col cols="12" md="2" class="black--text">{{ file._type }}</v-col>
                                    <v-col cols="12" md="2" class="black--text">{{ file.size | bytes }}</v-col>
                                    <v-col cols="12" md="2"><v-btn :href="file.url" target="_blank"
                                            icon><v-icon>mdi-download</v-icon></v-btn></v-col>
                                </v-row>
                                <v-alert text color="warning" v-if="!snapDocument.config.files.priceTable.length">Nenhuma
                                    tabela de preços encontrado</v-alert>
                            </fieldset>
                            <fieldset>
                                <legend>Arquivos complementares</legend>
                                <v-row v-for="(file, i) in snapDocument.config.files.complementary" :key="i">
                                    <v-col cols="12" md="6" class="black--text">{{ file.name }}</v-col>
                                    <v-col cols="12" md="2" class="black--text">{{ file._type }}</v-col>
                                    <v-col cols="12" md="2" class="black--text">{{ file.size | bytes }}</v-col>
                                    <v-col cols="12" md="2"><v-btn :href="file.url" target="_blank"
                                            icon><v-icon>mdi-download</v-icon></v-btn></v-col>
                                </v-row>
                                <v-alert text color="warning" v-if="!snapDocument.config.files.complementary.length">Nenhum
                                    arquivo complementar encontrado</v-alert>

                            </fieldset>

                            <v-row>
                                <v-col cols="12" md="6"><v-text-field label="Data de expiração da tabela"
                                        :value="snapDocument.config.expirationDate | dateCompact" readonly
                                        outlined></v-text-field></v-col>
                                <v-col cols="12" md="6"><v-text-field label="Precificação"
                                        :value="snapDocument.config.priceTable == 'gross' ? 'Bruto' : 'Líquido'" readonly
                                        outlined></v-text-field></v-col>
                            </v-row>

                            <!-- {{ snapDocument.config }} -->
                        </v-tab-item>

                    </v-tabs-items>
                    <div class="pt-3 d-flex">
                        <v-spacer>
                        </v-spacer>
                        <v-btn color="error" class="mx-1" elevation="0">Declinar</v-btn>
                        <v-btn color="success" elevation="0" @click="accept()">Aceitar</v-btn>
                    </div>
                </v-card-text>

            </v-card>
        </v-dialog>
    </div>
</template>
<script>
// import ExternalServices from './ExternalServices.vue';
import helper from '@/plugins/helper'
import config from "@/store/config";
import { mapGetters, mapActions, mapState } from "vuex";
import { initializeApp } from "firebase/app";
import {
    getFirestore,
    collection,
    doc,
    query,
    where,
    setDoc,
    getDocs,
} from "firebase/firestore";
import moment from 'moment'
export default {
    name: "PartnersRequests",
    components: {
        // ExternalServices
    },
    data() {
        return {
            loadingSnap: true,
            snapDocument: null,
            show: false,
            type: 1,
            search: null,
            loading: false,
            totalRegisters: 0,
            snapTab: 0,
            plug: {
                documents: []
            },
            snap: null,
            remove: null,
            items: [],
            options: {
                itemsPerPage: 10
            },
            expanded: [],
            singleExpand: true,
            handlerDelaySearch: null,
            headers: [
                { logo: "logo", value: "logo" },
                { text: "ID", value: "id", sortable: false },
                { text: "Nome", value: "name", sortable: false },
                //   { text: "Parceiro", value: "partner", sortable: true },
                { text: "Documento", value: "document", sortable: false },
                //   { text: "País", value: "location" },
                { text: "Display name", value: "displayName" },
                { text: "Criado em", value: "createdOn" },
                { text: "Status", value: "statusId" },

                { text: "", value: "actions", sortable: false },
            ],
        }
    },
    watch:
    {
        snap: {
            deep: true,
            handler(value) {
                this.loadingSnap = true
                this.snapDocument = null
                console.log('value', value)
                if (value) {
                    this.show = true
                    this.$axios
                        .get(`whitelabel/getConfig?profileId=${value.id}&admin=1`)
                        .then((response) => {
                            this.snapDocument = response.data.data
                            this.loadingSnap = false
                        })
                }
            }
        },
        show: {
            handler(value) {
                if (!value)
                    this.snap = false
            }
        },
        search() {
            clearInterval(this.handlerDelaySearch)
            this.handlerDelaySearch = setTimeout(() => {
                this.loadProfiles()
            }, 1000)
        },
        options: {
            handler() {
                this.loadProfiles()
            },
            deep: true,
        },
    },
    mounted() {
        this.loadProfiles()
    },
    methods: {
        ...mapActions("snackbar", ["showSnack"]),

        formatDate(date) {
            return this.$moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
        },
        accept() {
            // this.v$.$touch()
            // if (!this.v$.$invalid) {
            const Form = {
                createdOn: moment().format(),
                "master": false,
                "redirectURL": "",
                "adminUsers": [
                    {
                        admin: this.snapDocument.users.length ? { email: this.snapDocument.users[0].email, name: this.snapDocument.users[0].name } : null
                    }
                ],
                "id": helper.string_to_slug(`${this.snap.displayName}-${this.snap.id}-${this.snap.partner}`), //----- edit pls
                "logo": this.snap.logo, //----- edit pls
                "users": {
                    "leads": this.snapDocument.users.length ? { email: this.snapDocument.users[0].email, name: this.snapDocument.users[0].name } : null,
                    "content": this.snapDocument.users.length ? { email: this.snapDocument.users[0].email, name: this.snapDocument.users[0].name } : null,
                },
                "options": {
                    "includeTax": false,
                    "hidePackagesCPM": false,
                    "hideCoverage": false,
                    "priceView": true,
                    "noContent": false,
                    "restrictAccessText": "",
                    "asusNeedQuotation": false,
                    "hidePlacementHelper": false,
                    "hidePackages": false,
                    "hideOthersLang": true,
                    "packageNeedQuotation": false,
                    "hideSocialGraph": false,
                    "onlyNativeLanguage": true,
                    "hideAsus": false,
                    "contentBeforePayment": false,
                    "restrictAccessToWhitelist": false,
                    "hideCustomAudience": false,
                    "hideLocations": false
                },
                "info": {
                    "audience": {
                        "gender": {
                            "female": 50,
                            "male": 50
                        },
                        "customAudience": [

                        ],
                        "socialClass": [

                        ],
                        "ageGroup": [

                        ]
                    },
                    "about": {
                        "text1": "",
                        "image1": "",
                        "image2": "",
                        "text2": ""
                    }
                },
                "seo": {
                    "subtitle": "",
                    "allKeywords": [
                    ],
                    "description": "",
                    "title": ""
                },
                "disclaimers": [

                ],
                "sortSections": [
                    {
                        "active": true,
                        "id": "Categories",
                        "title": "Categorías"
                    },
                    {
                        "active": true,
                        "id": "packages",
                        "title": "Paquetes"
                    },
                    {
                        "active": true,
                        "id": "Featured",
                        "title": "Destacados"
                    },
                    {
                        "active": true,
                        "id": "formats",
                        "title": "Formatos"
                    },
                    {
                        "active": true,
                        "id": "Programs",
                        "title": "Programas"
                    },
                    {
                        "active": true,
                        "id": "sessions",
                        "title": "Sessões personalizadas"
                    }
                ],
                "packagesSorter": [],
                "name": this.snap.displayName, //----- change
                "searchSection": [
                    {
                        "active": true,
                        "id": "mediaType"
                    },
                    {
                        "active": true,
                        "id": "coverage"
                    },
                    {
                        "active": true,
                        "id": "locations"
                    },
                    {
                        "active": true,
                        "id": "buckets"
                    },
                    {
                        "active": true,
                        "id": "category"
                    },
                    {
                        "active": true,
                        "id": "format"
                    },
                     {
                        "active": true,
                        "id": "cities"
                    },
                    {
                        "active": true,
                        "id": "interests"
                    },
                    {
                        "active": true,
                        "id": "ageGroup"
                    },
                    {
                        "active": true,
                        "id": "gender"
                    },
                    {
                        "active": true,
                        "id": "socialClass"
                    },
                    {
                        "active": true,
                        "id": "sessions"
                    }
                ],
                "config": {
                    "titleColor": "#333333",
                    "primaryIconDark": false,
                    "primaryThemeDark": true,
                    "secondaryColor": "#4c4c4c",
                    "primaryColor": "#4c4c4c"
                },
                "advantage": "",
                "updatedOn": moment().format(),
                "locations": [
                ],
                "type": "partner",
                "url": helper.string_to_slug(`${this.snap.displayName}-${this.snap.partner}`), // ----------  critial
                "status": "published",
                "companyInfo": {
                    "footerText": `${this.snap.tradingName} - ${this.snap.document}`, //--- change pls
                    "terms": "",
                    "sacEmail": "sac@themediatrade.com",
                    "countryOrigin": "BRA",
                    "whatsApp": "+55 11 96392-94426", // ------- change, pls
                    "policy_privacy": "",
                    "paymentGateway": "pagarme",
                    "socialMedia": {
                        "twitter": "",
                        "facebook": "",
                        "instagram": "",
                        "linkedin": "",
                        "tiktok": "",
                        "youtube": ""
                    }
                }
            }
            console.log("Config...", config);
            if (config) {


                const firebase = initializeApp(config);
                console.log(Form);
                const db = getFirestore(firebase);
                setDoc(doc(db, "stores", Form.id), Form)
                    .then(() => {
                        this.$axios
                            .post(`whitelabel/acceptPartner`, {
                                id: this.snap.userId,
                                whitelabelId: Form.id
                            })
                            .then(() => {
                                this.loadProfiles();
                                this.dialog = false;
                                this.showSnack({
                                    text: this.$t("allStores.snackMessages.storeAdded"),
                                    color: "success",
                                    timeout: 2800,
                                    icon: "mdi-check",
                                });
                            });
                    })

            }
            // }

        },
        loadProfiles() {
            this.loading = true;
            const { sortBy, sortDesc, page, itemsPerPage, status } = this.options
            let queryString = {}
            queryString.status = 1
            queryString.pg = page
            queryString.pp = itemsPerPage
            if (this.search)
                queryString.q = this.search
            const params = new URLSearchParams(queryString).toString();
            this.$axios
                .get(`profiles/admin/all?type=2&partners='bgs'&${params}&pagination=1`)
                .then((response) => {
                    //pg=1&domain='+domain + "&type=2").then((res) =>{
                    this.totalRegisters = response.data.data.total
                    console.log('response.data;', response.data)
                    this.items = response.data.data.data;
                    this.loading = false;
                })
                .catch((error) => {
                    console.log("Error getting grids: ", error);
                    this.loading = false;
                });
        },
    }
};
</script>
<style>
fieldset {
    border-collapse: collapse;
    border-color: #999;
    border-style: solid;
    border-width: 1px;
    transition-duration: 0.15s;
    transition-property: color;
    border-radius: 4px;
    padding: 8px;
    margin-bottom: 5px;
}
</style>
